import { withInstall } from '@element-plus/utils/with-install'
import Progress from './src/progress.vue'

export const ElProgress = withInstall(Progress)
export default ElProgress

export * from './src/progress'
